export const getTelFormatWithCountryCode = tel => {
  return tel.replace(/^(?:0)/, '+66')
}
